import { useTranslation } from 'react-i18next';
import { Block, ScannerInput } from '@uni-space/uni-components';
import { getBagApiLabel } from '../api';
import { useLabelPrinter } from '@shared/labels';

export default function WbBagsLabel() {
  const { t, i18n } = useTranslation();

  const { isLabelLoading, printLabelFromFetcher } = useLabelPrinter({
    errorTitle: t('common.systemError.title'),
    fallbackErrorMessage: t('common.systemError.desc'),
  });

  const handleSubmit = async (value: string) => {
    await printLabelFromFetcher(() => getBagApiLabel(value));
  };

  return (
    <Block mH={8}>
      <ScannerInput
        lang={i18n.language}
        label={t('wbBagsLabel.scanner.bagNumber')}
        buttonLabel={t('send')}
        isLoading={isLabelLoading}
        disabled={isLabelLoading}
        onSubmit={handleSubmit}
      />
    </Block>
  );
}
